export function drawZach(zach, { screen, dist, rad, pointer }) {
  if (!zach) return;

  const flip = pointer.x > screen.width * 0.5;
  const scale = Math.max(1 * dist * 0.0005, 0.1);

  zach.rotation = rad + Math.PI * 2;
  zach.scale.x = scale * -1;
  zach.scale.y = scale * (flip ? 1 : -1);
}
